const E2E_SESSION_STORAGE_KEY = 'qsafe:e2e-session';
const E2E_ACCESS_STORAGE_KEY = 'qsafe:e2e-access';
const E2E_ENABLED_STORAGE_KEY = 'qsafe:e2e-enabled';

function isLocalAutomationRuntime() {
	if (typeof window === 'undefined') {
		return false;
	}

	const hostname = String(window.location?.hostname || '');
	const isLocalHost = hostname === '127.0.0.1' || hostname === 'localhost';
	return isLocalHost && window.navigator?.webdriver === true;
}

function readStorageJson(key) {
	if (typeof window === 'undefined') {
		return null;
	}

	try {
		const raw = window.localStorage.getItem(key);
		if (!raw) {
			return null;
		}
		return JSON.parse(raw);
	} catch {
		return null;
	}
}

export function isE2eMocksEnabled() {
	if (typeof window === 'undefined') {
		return false;
	}

	if (process.env.REACT_APP_ENABLE_E2E_MOCKS === 'true') {
		return true;
	}

	try {
		return window.localStorage.getItem(E2E_ENABLED_STORAGE_KEY) === 'true' && isLocalAutomationRuntime();
	} catch {
		return false;
	}
}

export function readE2eSession() {
	if (!isE2eMocksEnabled()) {
		return null;
	}

	const session = readStorageJson(E2E_SESSION_STORAGE_KEY);
	if (!session?.access_token || !session?.user?.id) {
		return null;
	}

	return session;
}

export function readE2eAccess() {
	if (!isE2eMocksEnabled()) {
		return null;
	}

	const access = readStorageJson(E2E_ACCESS_STORAGE_KEY);
	if (!access?.user_id || !Array.isArray(access?.permissions)) {
		return null;
	}

	return access;
}

export function clearE2eRuntime() {
	if (!isE2eMocksEnabled()) {
		return;
	}

	try {
		window.localStorage.removeItem(E2E_ENABLED_STORAGE_KEY);
		window.localStorage.removeItem(E2E_SESSION_STORAGE_KEY);
		window.localStorage.removeItem(E2E_ACCESS_STORAGE_KEY);
	} catch {
		// Ignore storage failures in test mode.
	}
}

export const E2E_RUNTIME_STORAGE_KEYS = {
	enabled: E2E_ENABLED_STORAGE_KEY,
	session: E2E_SESSION_STORAGE_KEY,
	access: E2E_ACCESS_STORAGE_KEY,
};
